module.exports = __webpack_public_path__ + "img/world-light.c38366e8.jpg";